// extracted by mini-css-extract-plugin
export var description = "index-module--description--2Eccz";